import React, { useState } from "react";
import "./whatsapp-fab.scss";

export default function WhatsAppFab() {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");

    const handleSend = (e) => {
        e.preventDefault();
        const msg = encodeURIComponent(message);
        window.open(`https://wa.me/919920088412?text=${msg}`, "_blank");
        setMessage("");
        setOpen(false);
    };

    return (
        <div className={`whatsapp-fab ${open ? "open" : ""}`}>
            {open && (
                <div className="whatsapp-fab-panel" role="dialog" aria-label="Message us on WhatsApp">
                    <div className="whatsapp-fab-head">
                        <span className="whatsapp-fab-label">Message us on WhatsApp</span>
                        <span className="whatsapp-fab-sub">Every day, 7 AM – 10 PM</span>
                    </div>
                    <form onSubmit={handleSend}>
                        <textarea
                            placeholder="Date, guests, occasion…"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            autoFocus
                        />
                        <button type="submit" className="btn-ink btn-sm">
                            <span>Send</span>
                            <i className="ri-send-plane-line"></i>
                        </button>
                    </form>
                </div>
            )}
            <button
                type="button"
                className="whatsapp-fab-main"
                aria-label={open ? "Close WhatsApp message" : "Open WhatsApp message"}
                aria-expanded={open}
                onClick={() => setOpen(!open)}
            >
                <i className={open ? "ri-close-line" : "ri-whatsapp-line"}></i>
            </button>
        </div>
    );
}
